exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html{position:relative;min-height:100%}body{margin-bottom:60px;background-image:-webkit-linear-gradient(115deg,#f9b233 74%,#f39200 0)}.header .container{background:#fff}.header .container .img-svg{width:100%;height:auto}.sub-header .container{background-color:#007d77;color:#fff}.main-content .container{background-color:hsla(0,0%,100%,.7)}.footer{position:absolute;bottom:0;width:100%;height:60px;line-height:60px;background-color:#f5f5f5}#app{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#2c3e50}h1,h2{font-weight:400}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-511e6782","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 203
// module chunks = 0